export {THEME, BRAND} from '../../globals/typings';

export enum CtaTarget {
  DESIGN = 'design',
  MODEL_SELECTION = 'model-selection',
  EQUIPMENT = 'equipment',
  DETAIL = 'detail',
}

export enum MccConfigurationStep {
  EXTERIOR,
  WHEELS,
}

export class MccError extends Error {
  constructor(message) {
    super(message);
    this.name = "MccError";
  }
}

export class MccLoadError extends MccError {
  status: number;
  url: string;
  constructor(message: string, status: number, url: string) {
    super(message);
    this.status = status;
    this.name = "MccLoadError";
    this.url = url;
  }
}

export class MccConfigError extends MccError {
  constructor(message) {
    super(message);
    this.name = "MccConfigError";
  }
}

export enum BREAKPOINT {
  XXS = 1,
  XS = 2,
  SM = 3,
  MD = 4,
  LG = 5,
  XL = 6,
  XXL = 7,
  XXXL = 8
}

class BreakpointMap {
  values: Map<BREAKPOINT, number>;

  constructor(xxs: number, xs: number, sm: number, md: number, lg: number, xl: number, xxl: number, xxxl: number) {
    this.values = new Map([
      [BREAKPOINT.XXS, xxs],
      [BREAKPOINT.XS, xs],
      [BREAKPOINT.SM, sm],
      [BREAKPOINT.MD, md],
      [BREAKPOINT.LG, lg],
      [BREAKPOINT.XL, xl],
      [BREAKPOINT.XXL, xxl],
      [BREAKPOINT.XXXL, xxxl]
    ]);
  }

  getValue(breakpoint: BREAKPOINT) {
    return this.values.get(breakpoint);
  }
}

export class BreakpointConfig {
  static breakpointValue(breakpoint: BREAKPOINT) {
    return new BreakpointMap(0, 375, 414, 768, 1024, 1440, 1920, 2560).getValue(breakpoint);
  }
}
